import { notifyError, notifySuccess } from "../components/snackbar/snackbar";
import { EditActiveBtnActions, MutableDict } from "../containers/centralView/dictionariesView/manageDicts/types/manageDictsProps";

export const checkOverwrite = (mutatedDictRec: MutableDict, existingDictionary: MutableDict[]) => {
    var existingRec = existingDictionary.find(item => item.ID === mutatedDictRec.ID);
    var overwrite = false;
    if (existingRec?.WARTOSC_EN !== mutatedDictRec.WARTOSC_EN && 
        existingRec?.WARTOSC === mutatedDictRec.WARTOSC &&
        existingRec?.KRYT_WYZN_TZ_GLOWNE_ID === mutatedDictRec.KRYT_WYZN_TZ_GLOWNE_ID) 
        {
            overwrite = true;
        }

    return overwrite;
}

export const checkIfEdited = (mutatedDictRec: MutableDict, existingDictionary: MutableDict[]) => {
    var existingRec = existingDictionary?.find(item => item.ID === mutatedDictRec?.ID)
    var checkValue = existingRec?.WARTOSC !== mutatedDictRec?.WARTOSC;
    var checkValueEng = existingRec?.WARTOSC_EN !== mutatedDictRec?.WARTOSC_EN;
    if (mutatedDictRec?.WARTOSC_EN === "" && existingRec?.WARTOSC_EN === null) checkValueEng = false;
    var checkCustomField = existingRec?.KRYT_WYZN_TZ_GLOWNE_ID !== mutatedDictRec.KRYT_WYZN_TZ_GLOWNE_ID;
    return checkValue || checkValueEng || checkCustomField;
} 

export const getNextRecOrder = (existingDictionary: MutableDict[]) => {
    var dictSortedByOrder = existingDictionary.sort((a, b) => a.KOLEJNOSC! - b.KOLEJNOSC!);
    return dictSortedByOrder[dictSortedByOrder.length - 1].KOLEJNOSC! + 1;
}

export const getActionBtnSnackbar = (action: EditActiveBtnActions, isSuccess: boolean) => {
    var successMsg = "";
    var failureMsg = "";
    
    switch (action) {
        case EditActiveBtnActions.Add:
            successMsg = "Dodano nową";
            failureMsg = "dodania nowej";
            break;
        case EditActiveBtnActions.Edit:
            successMsg = "Edytowano";
            failureMsg = "edycji";
            break;
        case EditActiveBtnActions.Delete:
            successMsg = "Usunięto";
            failureMsg = "usunięcia";
            break;
    }

    return isSuccess ? notifySuccess({ message: `${successMsg} pozycję słownikową` }) : notifyError({ message: `Próba ${failureMsg} pozycji słownikowej zakończona niepowodzeniem` });
}